module.exports = __webpack_public_path__ + "static/img/pttd_4@2x.dd92deae.png";